import React from "react";
import classNames from "classnames";
import { Button, Modal } from "react-bootstrap";
import invariant from "tiny-invariant";
import { ProductModalProps } from "../../types/order";

const CancelProductModal = ({
    show,
    product,
    handleClose,
    handleSubmit,
}: ProductModalProps): React.JSX.Element => {
    return (
        <Modal show={show} onHide={() => handleClose("cancelProduct")}>
            <Modal.Header>
                <Modal.Title className={classNames("text-center")}>
                    Are you show you want to cancel this registration?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Registration Info:</h6>
                <dl className={classNames("inline")}>
                    <dt>Tournament:</dt>
                    <dd>{product.description}</dd>
                    {product.meta.teamName && (
                        <>
                            <dt>Team:</dt>
                            <dd>{product.meta.teamName}</dd>
                        </>
                    )}
                </dl>
                <p className={classNames("mb-0")}>
                    Cancelling the registration will:
                </p>
                <ul>
                    <li>
                        Cancel <b>this</b> tournament registration.
                    </li>
                    <li>Update the number of open spots in this tournament</li>
                    <li>Remove the listed team from this tournament</li>
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => handleClose("cancelProduct")}
                >
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        invariant(product.meta.teamId);
                        handleSubmit(
                            "cancelProduct",
                            () => handleClose("cancelProduct"),
                            {
                                productId: product.id,
                                teamId: product.meta.teamId,
                            },
                        );
                    }}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelProductModal;
